module.exports = "/_next/static/resources/photo-2-0eee1202a9c2ecd07bb2539a59e90a99.webp";